// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge-light[data-v-40365be8] {\n  color: var(--dark);\n}\n.badge-dark[data-v-40365be8] {\n  color: var(--light);\n}", ""]);
// Exports
module.exports = exports;
